import { createVNode, render } from 'vue'
import toastPopup from '@/components/toast-popup/index.vue'
import i18n from '@/locales'

interface ToastOptions {
  type: 'success' | 'error'
  title: string
  message: string
  duration?: number
}

export interface ToastMethods {
  show: (options: ToastOptions) => void
  success: (message: string, title?: string, duration?: number) => void
  error: (message: string, title?: string, duration?: number) => void
}

function createToast(options: ToastOptions) {
  const container = document.createElement('div')
  document.body.appendChild(container)

  const vnode = createVNode(toastPopup, {
    ...options
  })

  render(vnode, container)

  // 清理 DOM
  setTimeout(() => {
    render(null, container)
    document.body.removeChild(container)
  }, options.duration || 3000)
}

export const toastPlugin = {
  success(
    message: string,
    title = i18n.global.t('Notifications'),
    duration = 3000
  ) {
    createToast({ type: 'success', message, title, duration })
  },
  error(message: string, title = i18n.global.t('Error'), duration = 3000) {
    createToast({ type: 'error', message, title, duration })
  },
  show(options: ToastOptions) {
    createToast(options)
  }
}
